<template>
  <div id="kanbancenter">
    <h1>{{$store.state.csr.name}}</h1>
    <ul>
      <li>欢迎使用智慧环卫云平台</li>
    </ul>
    <img src="static/kanbantop.png" />
    <Drawer
      placement="right"
      :closable="false"
      v-model="openGroup"
      draggable
      class="my-drawer"
    >
      <groupTree
        @group="reGroup"
        :filterGroup="false"
        :sousuo="true"
      ></groupTree>
    </Drawer>
  </div>
</template>
<script>
export default {
  data() {
    return { openGroup: false ,groupItem:{
      id:1,
      name:'项目部'
    }};
  },
  methods: {
    open() {
      this.openGroup = true;
    },
    reGroup(v) {
      this.groupItem=v;
    },
  },
};
</script>
<style>
#kanbancenter {
  width: 100%;
  height: 80px;
  margin-bottom: 10px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
#kanbancenter img {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -736px;
  z-index: 1;
}
#kanbancenter h1 {
  margin-top: 10px;
  font-size: 28px;
  margin-bottom: 4px;
  position: relative;
  z-index: 2;
}
#kanbancenter ul {
  width: 360px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
#kanbancenter ul li {
  margin: 0 5px;
  display: inline-block;
  font-size: 16px;
  color: #fff;
}
#kanbancenter ul li.active {
  color: #fff;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/control/kanbanselectGroup.vue